"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var theme_1 = require("../theme");
var BannerTimer = function (_a) {
    var disableDays = _a.disableDays, displayUnitsBottom = _a.displayUnitsBottom, endTime = _a.endTime, isSlider = _a.isSlider, showLabels = _a.showLabels, timerFontSize = _a.timerFontSize;
    var _b = react_1.useState(null), days = _b[0], setDays = _b[1];
    var _c = react_1.useState(null), hours = _c[0], setHours = _c[1];
    var _d = react_1.useState(null), minutes = _d[0], setMinutes = _d[1];
    var _e = react_1.useState(null), seconds = _e[0], setSeconds = _e[1];
    var intervalRef = react_1.useRef();
    var timer = react_1.useCallback(function () {
        var calculatedHours = 0;
        var countDownDate = new Date(endTime).getTime();
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var calculatedDays = Math.floor(distance / (1000 * 60 * 60 * 24));
        calculatedHours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        // If the days are disabled, add them to hours
        if (disableDays) {
            calculatedHours = calculatedDays * 24 + calculatedHours;
        }
        var calculatedMinutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var calculatedSeconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (distance < 0) {
            if (intervalRef && intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            setDays(0);
            setHours(0);
            setMinutes(0);
            setSeconds(0);
        }
        else {
            setDays(calculatedDays);
            setHours(calculatedHours);
            setMinutes(calculatedMinutes);
            setSeconds(calculatedSeconds);
        }
    }, [disableDays, endTime]);
    var hourSliceOffset = (!!hours || hours === 0) && hours.toString().length > 2 ? -hours.toString().length : -2;
    react_1.useEffect(function () {
        intervalRef.current = setInterval(timer, 1000);
    }, [timer]);
    return (react_1.default.createElement(TimerContainer, { isSlider: isSlider, displayUnitsBottom: displayUnitsBottom },
        !!days && days > 0 && !disableDays && (react_1.default.createElement("div", null, !displayUnitsBottom ? (react_1.default.createElement(TimerDigit, null,
            react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize },
                days,
                showLabels && react_1.default.createElement("span", null, "D"),
                "\u00A0:\u00A0"))) : (react_1.default.createElement(DigitContainer, null,
            react_1.default.createElement(TimerDigit, null,
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, days),
                showLabels && react_1.default.createElement(TimeUnits, null, days === 1 ? 'Day' : 'Days')),
            react_1.default.createElement(TimerDigit, { dots: true },
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, ":")))))),
        (!!hours || hours === 0) && (react_1.default.createElement("div", null, !displayUnitsBottom ? (react_1.default.createElement(TimerDigit, null,
            react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize },
                ("0" + hours).slice(hourSliceOffset),
                showLabels && react_1.default.createElement("span", null, "H"),
                "\u00A0:\u00A0"))) : (react_1.default.createElement(DigitContainer, null,
            react_1.default.createElement(TimerDigit, null,
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, ("0" + hours).slice(hourSliceOffset)),
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, showLabels && react_1.default.createElement(TimeUnits, null, hours === 1 ? 'Hour' : 'Hours'))),
            react_1.default.createElement(TimerDigit, { dots: true },
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, ":")))))),
        (!!minutes || minutes === 0) && (react_1.default.createElement("div", null, !displayUnitsBottom ? (react_1.default.createElement(TimerDigit, null,
            react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize },
                ("0" + minutes).slice(-2),
                showLabels && react_1.default.createElement("span", null, "M"),
                "\u00A0:\u00A0"))) : (react_1.default.createElement(DigitContainer, null,
            react_1.default.createElement(TimerDigit, null,
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, ("0" + minutes).slice(-2)),
                react_1.default.createElement(TimeUnits, null, showLabels && react_1.default.createElement(TimeUnits, null, minutes === 1 ? 'Minute' : 'Minutes'))),
            react_1.default.createElement(TimerDigit, { dots: true },
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, ":")))))),
        (!!seconds || seconds === 0) && (react_1.default.createElement("span", null,
            ' ',
            !displayUnitsBottom ? (react_1.default.createElement(TimerDigit, null,
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize },
                    ("0" + seconds).slice(-2),
                    " ",
                    showLabels && react_1.default.createElement("span", null, "S")))) : (react_1.default.createElement(TimerDigit, null,
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, ("0" + seconds).slice(-2)),
                react_1.default.createElement(DealTimer, { timerFontSize: timerFontSize }, showLabels && react_1.default.createElement(TimeUnits, null, seconds === 1 ? 'Second' : 'Seconds'))))))));
};
var TimerContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    direction: ltr;\n    ", "\n    ", "\n    ", ";\n"], ["\n    display: flex;\n    direction: ltr;\n    ",
    "\n    ",
    "\n    ", ";\n"])), function (_a) {
    var displayUnitsBottom = _a.displayUnitsBottom;
    return displayUnitsBottom ? 'flex-direction: row;' : '';
}, function (_a) {
    var isSlider = _a.isSlider;
    return isSlider ? 'margin-top: 15px;' : '';
}, function (_a) {
    var theme = _a.theme;
    return (theme.isRTL ? " margin-right: 0px; margin-top: -4px;" : "");
});
var TimerDigit = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0px;\n    font-size: 1.333rem;\n    font-size: 2vw;\n    ", "\n\n    @media ", " {\n        font-size: 3vw;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0px;\n    font-size: 1.333rem;\n    font-size: 2vw;\n    ",
    "\n\n    @media ", " {\n        font-size: 3vw;\n    }\n"])), function (_a) {
    var dots = _a.dots;
    return "" + (dots ? 'padding: 0px 3px;' : '');
}, theme_1.breakpoints.minTablet);
var DealTimer = styled_components_1.default.span(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var timerFontSize = _a.timerFontSize;
    return "fontSize: " + timerFontSize + "px";
});
var DigitContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n"])));
var TimeUnits = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n    font-size: 10px;\n    padding: 0 4px;\n\n    @media ", " {\n        padding: 0 2px;\n    }\n"], ["\n    font-size: 10px;\n    padding: 0 4px;\n\n    @media ", " {\n        padding: 0 2px;\n    }\n"])), theme_1.breakpoints.minTablet);
exports.default = BannerTimer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=BannerTimer.js.map